import { connect } from "react-redux";
import useEmpresa from "../../../hooks/useEmpresa";
import { formatearMontoPesos } from "../../../utils/CurrencyUtil";
import {
  DATOS_FIJOS_AUTORIZACION,
  CODIGO_TIPO_SERVICIO_AUTORIZACION,
  DESCRIPCION_PLAN,
  CHECK_FISICO_REQUERIDO
} from "../utils/AutorizacionConstant";
import moment from "moment";
import CheckRender from "../../../components/Common/CheckRender";

const VoucherAutorizacion = (props) => {
  const {
    numeroAutorizacion,
    dataAutorizacion,
    procedimientos,
    isVoucherMatricial,
  } = props;

  const { prestador } = props?.authUserData;

  const empresa = useEmpresa();

  const getMontoTotalAutorizado = () => {
    return procedimientos?.reduce(
      (acumulador, procedimiento) => acumulador + procedimiento.montoAutorizado,
      0
    );
  };

  const getMontoTotalDiferencia = () => {
    return procedimientos?.reduce(
      (acumulador, procedimiento) => acumulador + procedimiento.montoDiferencia,
      0
    );
  };

  return (
    <table
      width="227"
      border="0"
      cellspacing="1"
      cellpadding="2"
      style={{ fontSize: isVoucherMatricial ? "11px" : "9px" }}
    >
      <tr>
        <td colspan="2" align="center">
          <img src={empresa?.LOGO_AZUL} width="134" alt="logo" />
        </td>
      </tr>
      <tr>
        <td colspan="2" align="center">
          <b>Datos de reclamaci&oacute;n</b>
        </td>
      </tr>
      <tr>
        <td width="50%">No. Autorizaci&oacute;n</td>
        <td align="right">
          <b>{numeroAutorizacion}</b>
        </td>
      </tr>
      <tr>
        <td>Fecha</td>
        <td align="right">{dataAutorizacion?.fecha}</td>
      </tr>
      <tr>
        <td colspan="2">
          Sres.
          <br />
          <b>{prestador?.nombre}</b>
        </td>
      </tr>
      <tr>
        <td>C&oacute;digo</td>
        <td>{prestador?.codigo}</td>
      </tr>
      <tr>
        <td>Prescriptor</td>
        <td>{dataAutorizacion?.medicoPrescriptor}</td>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <td colspan="2">
          <p>
            Autorizamos a suministrar a nuestro afiliado
            <br />
            {`${dataAutorizacion?.nombres} ${dataAutorizacion?.apellidos}`}
          </p>
        </td>
      </tr>
      <tr>
        <td>Carnet No. </td>
        <td>{dataAutorizacion?.numeroAfiliado}</td>
      </tr>
      <tr>
        <td>Documento No. </td>
        <td>{dataAutorizacion?.cedula}</td>
      </tr>
      <tr>
        <td>Tel&eacute;fono. </td>
        <td>{dataAutorizacion?.telefono}</td>
      </tr>
      <tr>
        <td>Contratante</td>
        <td></td>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td></td>
      </tr>
      <tr>
        <td>Plan</td>
        <td>
          {String(dataAutorizacion?.tipoServicio) ===
          CODIGO_TIPO_SERVICIO_AUTORIZACION.PROMOCION_PREVENCION
            ? DESCRIPCION_PLAN.PLAN_BASICO
            : dataAutorizacion?.plan}
        </td>
      </tr>
      <tr>
        <td valign="top">Dx.</td>
        <td>{dataAutorizacion?.diagnostico}</td>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td align="right">&nbsp;</td>
      </tr>
      <tr>
        <td colspan="2" align="left" valign="top">
          <table width="100%" border="0" cellspacing="1" cellpadding="2">
            {procedimientos?.map((procedimiento, index) => {
              return (
                <>
                  <tr>
                    <td colspan="4">
                      <b>
                        {procedimiento?.nombreCobertura ||
                          procedimiento?.cobertura}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td align="center">Cobert.</td>
                    <td align="center">Cant.</td>
                    <td align="center">ARS</td>
                    <td align="center">Afiliado</td>
                  </tr>
                  <tr>
                    <td align="center">{procedimiento?.cobertura}</td>
                    <td align="center">{procedimiento?.cantidad}</td>
                    <td align="right">
                      {formatearMontoPesos(
                        String(procedimiento?.montoAutorizado)
                      )}
                    </td>
                    <td align="right">
                      {formatearMontoPesos(
                        String(procedimiento?.montoDiferencia)
                      )}
                    </td>
                  </tr>
                </>
              );
            })}

            <tr>
              <td colspan="2" align="right">
                <b>Total:</b>{" "}
              </td>
              <td align="right">
                <b>{formatearMontoPesos(String(getMontoTotalAutorizado()))}</b>
              </td>
              <td align="right">
                <b>{formatearMontoPesos(String(getMontoTotalDiferencia()))}</b>
              </td>
            </tr>
          </table>
          <p>&nbsp;</p>
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td width="50%">Autorizaci&oacute;n v&aacute;lida hasta: </td>
              <td align="right">
                <b>
                  {moment(dataAutorizacion?.fecha)
                    ?.add(
                      DATOS_FIJOS_AUTORIZACION.FECHA_VALIDA_HASTA
                        .CANTIDAD_TIEMPO,
                      DATOS_FIJOS_AUTORIZACION.FECHA_VALIDA_HASTA
                        .INTERVALO_TIEMPO
                    )
                    ?.format("YYYY-MM-DD")}
                </b>
              </td>
            </tr>
            <tr>
              <td>Oficial de Servicios: </td>
              <td>{dataAutorizacion?.usuarioIngreso}</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td>Observaciones:</td>
              <td></td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td colspan="2">
                Autorizo la revisi&oacute;n de mi expediente m&eacute;dico al
                personal de Auditor&iacute;a M&eacute;dica designado por
                <br />
                Humano con el fin de evaluar integralmente la atenci&oacute;n
                prestada.{" "}
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
          </table>
          <table border="0" align="center" cellpadding="0" cellspacing="0">
            <CheckRender allowed={dataAutorizacion?.requiereFisico !== CHECK_FISICO_REQUERIDO.NO_REQUERIDO}>
              <tr>
                <td width="10" height="80" valign="bottom">
                  &nbsp;
                </td>
                <td valign="bottom">
                  <div align="center">
                    _________________________________ <br />
                    Firma del Afiliado
                  </div>
                </td>
                <td valign="bottom" width="10">
                  &nbsp;
                </td>
              </tr>
              <tr>
                <td width="10" height="80" valign="bottom">
                  &nbsp;
                </td>
                <td valign="bottom">
                  <div align="center">
                    _________________________________ <br />
                    Firma y Sello del Reclamante
                  </div>
                </td>
                <td valign="bottom" width="10">
                  &nbsp;
                </td>
              </tr>
            </CheckRender>
            <CheckRender allowed={dataAutorizacion?.requiereFisico === CHECK_FISICO_REQUERIDO.NO_REQUERIDO}>
              <tr>
                <td width="10" height="80" valign="bottom">
                  &nbsp;
                </td>
                <td valign="bottom">
                  <div align="center">Firma no requerida</div>
                </td>
                <td valign="bottom" width="10">
                  &nbsp;
                </td>
              </tr>
            </CheckRender>
          </table>
        </td>
      </tr>
    </table>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(VoucherAutorizacion);
